<vwui-modal-header>
    <h2 a11yPageTitleLevel="2">{{ 'PROJECT_NOTES.modal.title' | translate }}</h2>
</vwui-modal-header>

<vwui-modal-body>
    <vwui-form-group label="{{ 'PROJECT_NOTES.modal.message' | translate }}" inputId="noteMessage">
        <vwui-textarea inputId="noteMessage" [(ngModel)]="message"></vwui-textarea>
    </vwui-form-group>
</vwui-modal-body>

<vwui-modal-footer>
    <vwui-button (click)="modalRef.close(false)" class="is-secondary">
        {{ 'BUTTON.cancel' | translate }}
    </vwui-button>
    <vwui-button (click)="save()" [disabled]="!canSave()" [loading]="isSaving" class="is-primary">
        {{ 'BUTTON.save' | translate }}
    </vwui-button>
</vwui-modal-footer>
